export enum OrdersPreviewColumnTypeEnum {
  RETURN = 'Return',
  ORDER = 'Order',
}
